import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import fullscreen from 'vue-fullscreen'
import VCalendar from 'v-calendar'
import Transitions from 'vue2-transitions'
import VMoment from 'vue-moment'

import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import './registerServiceWorker'

// To Run on prod DB via Powershell use: $env:API_BASE_URL="https://cer.openindustry.org"; yarn dev

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(BootstrapVue)

Vue.use(fullscreen)

Vue.use(VCalendar)

Vue.use(Transitions)

Vue.use(VMoment)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
